// Downloads of the public Vodin installation package (16.10.2026): what the
// hub counts under GET /api/Updates/setup/downloads, parsed once at the edge.
// Per version all time, the last 30 days and today (UTC); no client data.

export type DownloadTotal = {
    version: string,
    total: number,
    lastDays: number,
    today: number,
};

const isCount = (value: unknown): value is number =>
    typeof value === "number" && Number.isInteger(value) && value >= 0;

/** One row, or null for anything that is not one. */
export function parseTotal(json: unknown): DownloadTotal | null {
    if (typeof json !== "object" || json === null) {
        return null;
    }
    const { version, total, lastDays, today } = json as Record<string, unknown>;
    return typeof version === "string" && version.length > 0
        && isCount(total) && isCount(lastDays) && isCount(today)
        ? { version, total, lastDays, today }
        : null;
}

/** The rows of an answer; anything malformed is left out, a non-list is empty. */
export const parseTotals = (json: unknown): DownloadTotal[] =>
    Array.isArray(json)
        ? json.map(parseTotal).filter((t): t is DownloadTotal => t !== null)
        : [];

/** The sum over all versions, for the card's title line. */
export const overall = (totals: readonly DownloadTotal[]): DownloadTotal =>
    totals.reduce(
        (sum, t) => ({ version: "", total: sum.total + t.total, lastDays: sum.lastDays + t.lastDays, today: sum.today + t.today }),
        { version: "", total: 0, lastDays: 0, today: 0 });

export const downloadsPath = (api: string): string => `${api}/Updates/setup/downloads`;
